/* Aurora mobile menu — drawer behaviour for sections/aurora-mobile-menu.liquid.

   The header keeps Dawn's stock <header-drawer> burger. While this section exists we
   intercept the burger's click (capture phase, before Dawn's details/summary toggle)
   and open this drawer instead. Remove the section in the editor and the stock menu
   drawer takes over again — nothing else to undo. */
(function () {
  class AuroraMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      var self = this;

      // capture-phase: beat both the <details> default toggle and Dawn's HeaderDrawer JS
      this._burger = function (e) {
        var burger = e.target.closest('[data-mm-open], header-drawer summary');
        if (!burger) return;
        e.preventDefault();
        e.stopPropagation();
        self.open();
      };
      document.addEventListener('click', this._burger, true);

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-mm-close]')) return self.close();
        // localization block: hand off to the aurora localization drawer's own trigger
        if (e.target.closest('[data-mm-localization]')) {
          self.close();
          var t = document.querySelector('[data-aurora-loc-open]');
          if (t) t.click();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._burger, true);
      document.body.classList.remove('aurora-mm-locked'); // editor removes the section while open
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('aurora-mm-locked'); // lock: html:has() rules in aurora.css
      var f = this.querySelector('.aurora-mm__close');
      if (f) f.focus({ preventScroll: true });
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('aurora-mm-locked');
    }
  }
  if (!customElements.get('aurora-mobile-menu')) customElements.define('aurora-mobile-menu', AuroraMobileMenu);

  /* theme editor: opening the section's settings should show the drawer */
  document.addEventListener('shopify:section:select', function (e) {
    var mm = e.target && e.target.querySelector && e.target.querySelector('aurora-mobile-menu');
    if (mm && mm.open) mm.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var mm = e.target && e.target.querySelector && e.target.querySelector('aurora-mobile-menu');
    if (mm && mm.close) mm.close();
  });
})();
